// AUTO-GENERATED — DO NOT EDIT
//     run `just codegen-experiment-function … --frontend-client --target-app ask` to regenerate.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useCometControlBrowserSkillEnabledVariation = makeBooleanFlagValueHook('comet-control-browser-skill-enabled');
//# sourceMappingURL=useCometControlBrowserSkillEnabledVariation.js.map